<template>
  <main>
    <Sub-tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        異動後實質接觸追蹤表
                    </h4>
                    <form class="form">
                        <div class="form-group row">
                            <label class="col-1 text-right">受撥月份</label>
                            <div class="col-11">
                                <select class="form-control form-control-inline ml-0" v-model="form.startYear">
                                    <option value="108">108 年</option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.startMonth">
                                    <option value="1">1 月</option>
                                </select>
                                <span class="text">～</span>
                                <select class="form-control form-control-inline" v-model="form.endYear">
                                    <option value="108">108 年</option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.endMonth">
                                    <option value="2">2 月</option>
                                </select>
                                <a @click="searchData()" class="btn btn-primary mt-0">查詢</a>
                                <div>
                                    <div class="checkbox">
                                    <input type="checkbox" v-model="form.vip" id="onlyvip" value="true">
                                    <label for="onlyvip">僅顯示VIP</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                        <label class="col-1 text-right">路徑</label>
                        <div class="col-11">
                            <ul class="breadcrumb-list">
                                <li :class="{
                                'active': currentRowID == null
                                }">
                                    <a role="button" @click="currentRowID = null">全部</a>
                                </li>
                                <li class="bread"
                                :class="{
                                'active': bread.id === currentRowID
                                }"
                                v-for="(bread, i) in breadcrumbs"
                                :key="`bread-${i}`">
                                    <a role="button" @click="currentRowID = bread.id">{{bread.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="col-12">
                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th rowspan="2" width="100">系統別</th>
                                <th class="text-right">應完成<br/>人數</th>
                                <th class="text-right">未完成<br/>人數</th>
                                <th class="text-right">完成人數<br/>(6個月內)</th>
                                <th class="text-right">完成人數<br/>(12個月內)</th>
                                <th class="text-right">完成人數<br/>(13個月以上)</th>
                                <th class="text-right">實質接觸率<br/>(人)%<br/>(6個月內)</th>
                                <th class="text-right">實質接觸率<br/>(人)%<br/>(12個月內)</th>
                                <th class="text-right">實質接觸率<br/>(人)%<br/>(13個月以上)</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="row.child" @click="currentRowID = row.id" class="link text-underline">{{row.type}}</a>
                              <span v-else>{{row.type}}</span>
                            </td>
                            <td class="text-right">{{row.shouldComplete | numberFormat}}</td>
                            <td class="text-right">{{row.notComplete | numberFormat}}</td>
                            <td class="text-right">{{row.ccmplete1 | numberFormat}}</td>
                            <td class="text-right">{{row.ccmplete2 | numberFormat}}</td>
                            <td class="text-right">{{row.ccmplete3 | numberFormat}}</td>
                            <td class="text-right">{{row.touchRate1}}%</td>
                            <td class="text-right">{{row.touchRate2}}%</td>
                            <td class="text-right">{{row.touchRate3}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="9">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="9">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="tableRow && tableRow.length">
                          <tr class="bg-white">
                            <th class="text-left">合計</th>
                            <th class="text-right">{{countTotal('shouldComplete') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('notComplete') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('ccmplete1') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('ccmplete2') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('ccmplete3') | numberFormat}}</th>
                            <th class="text-right">{{countTotal('touchRate1')}}%</th>
                            <th class="text-right">{{countTotal('touchRate2') | numberFormat}}%</th>
                            <th class="text-right">{{countTotal('touchRate3') | numberFormat}}%</th>
                          </tr>
                        </tfoot>
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        <ol>
                            <li>實質接觸項目同未訪件</li>
                            <li>如有其他疑問，請洽總公司業務部企劃科，(02)27551399#2032、2039</li>
                        </ol>
                    </div>
                </div>

            </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import SubTabHeader from '@/desktop/components/submanager/TabHeader'

const dataTree = [
  {
    parent: null,
    id: 1,
    type: '專招',
    shouldComplete: 32827,
    notComplete: 121,
    ccmplete1: 0,
    ccmplete2: 0,
    ccmplete3: 0,
    touchRate1: 27.9,
    touchRate2: 0.0,
    touchRate3: 0.0,
    child: true
  },
  {
    parent: null,
    id: 2,
    type: '展業',
    shouldComplete: 98329,
    notComplete: 67975,
    ccmplete1: 30354,
    ccmplete2: 0,
    ccmplete3: 0,
    touchRate1: 30.9,
    touchRate2: 0.0,
    touchRate3: 0.0,
    child: true
  }
]

export default {
  name: 'TransferTab51',
  mixins: [commonMixin],
  components: {
    SubTabHeader
  },
  computed: {
    tableRow () {
        if (this.currentRowID==0) return null
        this.dataTree = dataTree
        return this.dataTree.filter(row => row.parent == this.currentRowID)
    },
    breadcrumbs () {
      if(this.currentRowID==0)
        return []
      else
        return (this.getParentPath(this.currentRowID)).reverse()
    }
  },
  data () {
    return {
      form: {
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      },
      order: {
          index: 1,
          asc: true
      },
      dataTree: [],
      currentRowID: 0,
    }
  },
  watch: {
      'searchType': 'changeData'
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    getParentPath (parent) {
      let path = []
      this.dataTree.forEach(row => {
        if (row.id == parent) {
          path.push({
            id: row.id,
            name: row.type
          })
          if (row.parent) {
            path = path.concat(this.getParentPath(row.parent))
          }
        }
      })
      // console.log(parent, path)
      return path
    },
    searchData () {
      this.currentRowID = null;
      // this.getPath(this.tableRow)
    },
    countTotal (key) {
      let list =  this[''] 
      if (!this.tableRow) return
      
      let num = 0
      this.tableRow.forEach(row => {
        num += row[key]
      })

      if(key.toLowerCase().indexOf('rate') > -1) {
        num =  num/this.tableRow.length
      }
      return num
    },
    changeData () {
        // Call API
      // this.breadcrumbs = []
      this.currentRowID = 0;
    }
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>
